<template>
	<div>
		<el-dialog title="发布二手" :visible="SecondHand" width="70%" @close="close">
			<el-form :model="items" :rules="rules" ref="ruleForm" label-width="100px">
			<div>
				<div class="classifys">
					<el-col :span="5">
						<el-form-item label="分类:" prop="category_id">
							<el-select v-model="categoryOne" placeholder="请选择一级分类" @change="changeCategory">
								<el-option
										v-for="item in categoryOnes"
										:key="item.value"
										:label="item.label"
										:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col style="margin-left:-30px" :span="5">
						<el-form-item  prop="category_id" >
						<el-select v-model="categoryTwo" placeholder="请选择二级分类" @change="changeCategoryTwo">
							<el-option
									v-for="item in categoryTwos"
									:key="item.value"
									:label="item.label"
									:value="item.value">
							</el-option>
						</el-select>
						</el-form-item>
					</el-col>
				</div>
				<div class="classifys">
					<el-form-item label="品牌名称:" prop="brand_name">
						<el-input  v-model="items.brand_name" placeholder="请输入品牌名称"></el-input>
					</el-form-item>
				</div>
				<div class="classifys">
					<el-form-item label="标题:" prop="title">
						<el-input  v-model="items.title" placeholder="请输入标题"></el-input>
					</el-form-item>
				</div>
				<div class="classifys">
					<el-form-item label="价格:" prop="sale_price">
						<el-input  maxlength="9" type="number" v-model="items.sale_price" placeholder="请输入销售价格"></el-input>
					</el-form-item>
				</div>
				<div class="classifys">
					<el-form-item label="原价:" prop="price">
						<el-input  type="number" v-model="items.price" placeholder="请输入原价"></el-input>
					</el-form-item>
				</div>
				<!--<div class="classifys">
					<el-col :span="5">
						<el-form-item label="价格:" prop="sale_price">
							<el-input v-model="items.sale_price" placeholder="请输入销售价格"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="原价:" prop="price">
							<el-input v-model="items.price" placeholder="请输入原价"></el-input>
						</el-form-item>
					</el-col>
				</div>-->
				<div class="classifys">
					<el-form-item label="联系方式:" prop="mobile">
						<el-input v-model="items.mobile" placeholder="请输入您的联系方式"></el-input>
					</el-form-item>
				</div>
				<div class="classifys">
					<el-form-item label="交易方式:" prop="achieve_type">
						<el-radio-group v-model="items.achieve_type">
							<el-radio label="1">私下交易</el-radio>
							<el-radio label="2">平台担保交易</el-radio>
						</el-radio-group>
					</el-form-item>
				</div>
				<div class="classifys">
					<el-form-item label="成色:">
						<span v-for="(item,index) in purity" v-bind:key="item.index"
							  @click="changePurity(index,item.id)" ref="companyTypeDOM"
							  :class="index == 0? 'first-select' : 'select'">{{item.name}}</span>
					</el-form-item>
				</div>
				<div  class="classifys">
					<el-form-item label="封面:" >
						<el-upload
								:http-request="coveruploads"
								list-type="picture-card"
								:on-preview="handlePictureCardPreview"
								:limit="1"
								:before-upload="coverUpload"
						>
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</div>
				<div  class="classifys">
					<el-form-item label="相册:" >
						<el-upload
								:http-request="photosuploads"
								list-type="picture-card"
								:on-preview="handlePictureCardPreview"
								:before-upload="photoUpload"

						>
							<i class="el-icon-plus"></i>
						</el-upload>
					</el-form-item>
				</div>
				<div class="classifys">
					<el-form-item label="城市:" prop="city" >
						<el-cascader
								size="large"
								:options="options"
								v-model="selectedOptions"
								@change="cityChange">
						</el-cascader>
					</el-form-item>
				</div>
				<div  class="classifys">
					<el-form-item label="描述:" >
						<el-input style="width:600px;" type="textarea"  v-model="items.content"></el-input>
					</el-form-item>
				</div>
				<div  class="classifys">
					<el-form-item label="介绍:" >
						<el-input style="width:600px;" type="textarea"  v-model="items.description"></el-input>
					</el-form-item>
				</div>
			</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
              <button style="outline:none;cursor:pointer" @click="submit('ruleForm')" v-bind:disabled="submitDisabled">发布</button>
            </span>
		</el-dialog>
	</div>
</template>

<script>
	import { regionData,CodeToText } from 'element-china-area-data'
	import axios from 'axios'
	import {setCookie,getCookie,clearCookie} from '@/common/js/common'
	import CanvasCompress from 'canvas-compress';
	export default {
		name: "second-hand",
		data(){
				 var validatePass = (rule, value, callback) => {
					 var myreg=/^[1][3,4,5,7,8][0-9]{9}$/
							if (!myreg.test(value)) {
							callback(new Error('请输入正确的手机号'));
							}
						};
			return {
				submitDisabled:false,
				options: regionData,
				selectedOptions: [],
				categoryOnes:[],//一级分类 合集
				categoryOne:'',//一级分类
				categoryTwos:[], //二级分类
				categoryTwoss:[], //二级分类
				categoryTwo:'', //二级分类
				brand:[],//品牌
				type:[],//类型
				cover_img:[],//封面图
				purity:[], //取成色
				items:{
					brand_name:'',
					purity_id:1, //成色ID
					category_id:'',//分类ID
					brand_id:'',		//品牌
					type_id:'',			//型号
					sale_price:'',	//销售价格
					price:'',		//原价
					mobile:'',		//联系方式
					cover_img:'',    //封面
					photos:'',  //相册多个用逗号隔开
					province:'',// 省
					city:'',// 市
					district:'',// 区
					achieve_type:'1',//交易方式
					city_id:'',//城市ID
					user_id:'',
					content:'',//描述,
					description:'',//介绍，
					idle_type:1
				},
				dialogVisible: false,
				dialogImageUrl: '',
				rules: {
					brand_name:[
						{ required: true, message: '请输入品牌名称', trigger: 'blur' },
					],
					category_id:[
						{ required: true, message: '请选择分类', trigger: 'blur' },
					],
					brand_id:[
						{ required: true, message: '请选择品牌', trigger: 'blur' },
					],
					type_id:[
						{ required: true, message: '请选择型号', trigger: 'blur' },
					],
					title:[
						{ required: true, message: '请输入标题', trigger: 'blur' },
						{ min: 1, max:100, message: '标题不能过长', trigger: 'blur' }
					],
					sale_price:[
						{ required: true, message: '请输入原价', trigger: 'blur' },
						{ min: 1, max:10, message: '价格最大不能超过10位数', trigger: 'blur' }
					],
					price:[
						{ required: true, message: '请输入价格', trigger: 'blur' },
						{ min: 1, max:10, message: '价格最大不能超过10位数', trigger: 'blur' }
					],
					mobile:[
						{pattern: /^[1][3,4,5,7,8][0-9]{9}$/,
						required: true, message: '请输入联系方式', trigger: 'blur' },
						// { validator: validatePass, trigger: 'blur' }
					],
					city:[
						{ required: true, message: '请选择城市', trigger: 'blur' },
					]
				}
			}
		},
		props:['SecondHand'],
		created () {
			this.getCategory();
			this.getBrand();
			this.getPurity();
		},
		methods:{
			coveruploads(e){
					let form=new FormData();
					form.append("file",e.file)
				this.$upload(form).then(res=>{
				this.items.cover_img=res.data.url;
				})
				
			},
				// 相册上传成功
			photosuploads(e){
					let form=new FormData();
					form.append("file",e.file)
				this.$upload(form).then(response=>{
				if(this.items.photos!=''){
					this.items.photos=this.items.photos+','+response.data.url;
				}else{
					this.items.photos=response.data.url;
				}
				})
			},
			//城市选择事件
			cityChange (value) {
				console.log(value[0]);
				this.items.province=CodeToText[value[0]];
				this.items.city=CodeToText[value[1]];
				this.items.district=CodeToText[value[2]];
				this.items.city_id=value[2];
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handlePreview(file) {
				console.log(file);
			},
			// 封面压缩
			async coverUpload(file) {
				const compressor = new CanvasCompress({
					type: CanvasCompress.MIME.JPG,
					width: 1000,
					height: 618,
					quality: 0.5,
			});
				// console.log('uploadToken', res.data)
				// console.log('beforeUpload', file)
				let {source, result} = await compressor.process(file)
				//console.log(source)
				// console.log('compress', result)
				let fileInfo = new File([result.blob],file.name,{type:file.type})
				return Promise.resolve(fileInfo)//只要在这里返回一个立即resolve的Promise对象，压缩后的文件作为参数即可实现压缩
			},
			// 相册压缩
			async photoUpload(file) {
				const compressor = new CanvasCompress({
					type: CanvasCompress.MIME.JPEG,
					width: 1000,
					height: 618,
					quality: 0.5,
			});
				// console.log('uploadToken', res.data)
				// console.log('beforeUpload', file)
				let {source, result} = await compressor.process(file)
				let fileInfo = new File([result.blob],file.name,{type:file.type})
				return Promise.resolve(fileInfo)//只要在这里返回一个立即resolve的Promise对象，压缩后的文件作为参数即可实现压缩
			},
			// 封面上传成功
			coverSuccess(response, file, fileList){
				this.items.cover_img=response.data.url;
			},
			covererror(err, file, fileList){
				console.log(err)
			},
			coverExceed(){
				this.$message.warning(`封面只能上传一张`);
			},
			// 相册上传成功
			photosSuccess(response, file, fileList){
				if(this.items.photos!=''){
					this.items.photos=this.items.photos+','+response.data.url;
				}else{
					this.items.photos=response.data.url;
				}
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},
			// 获取分类
			getCategory(){
				let _this = this;
				_this.$get('/apis/idle/IdleCategory/parent/0').then((res)=>{
					res.data.forEach(function(value,index){
						_this.categoryOnes.push({value:value.id,label:value.name});
						// 填充二级分类
						if(value._children.length !== 0){
							value._children.forEach(function(values,indexs){
								_this.categoryTwoss.push({value:values.id,label:values.name,pid:values.parent_id});
							})
						}
					});
				})
			},
			// 获取品牌
			getBrand(){
				let _this = this;
				_this.$get('/apis/idle/idleBrand?page=nopage').then((res)=>{
					res.data.forEach(function(value,index){
						_this.brand.push({value:value.id,label:value.name});
					});
				})
			},
			//获取成色
			getPurity(){
				let _this = this;
				_this.$get('/apis/idle/idlePurity?page=nopage').then((res)=>{
					res.data.forEach(function(value,index){
						_this.purity.push({id:value.id,name:value.name});
					});
				})
			},
			// 选择品牌触发
			changeBrand(value){
				let _this = this;
				_this.items.type_id='';
				_this.$get('/apis/idle/idleBrandType?page=nopage&brand='+value).then((res)=>{
					let arr = [];
					res.data.forEach(function(values,indexs){
						arr.push({value:values.id,label:values.name});
					});
					_this.type=arr;
				})
			},
			// 选择一级分类触发
			changeCategory(value){
				let _this = this;
					this.categoryTwo=''
				_this.items.category_id=value;
				let arr = [];
				_this.categoryTwoss.forEach(function(values,indexs){
					if(values.pid==value){
						arr.push({value:values.value,label:values.label});
					}
				})
				_this.categoryTwos=arr;
			},
			close(){
				this.$emit('update:SecondHand',false)
			},
			//选择二级分类触发
			changeCategoryTwo(value){
				this.items.category_id=value;
			
			},
			// 成色选取变色
			changePurity(index,id) {
				this.items.purity_id=id;
				this.$refs.companyTypeDOM.forEach((ele, Mindex) => {
					index === Mindex ? (this.$refs.companyTypeDOM[Mindex].style.color = '#F9BE04')
						: (this.$refs.companyTypeDOM[Mindex].style.color = '#D3D3D2')

					index === Mindex ? (this.$refs.companyTypeDOM[Mindex].style.border = '1px solid #F9BE04')
						: (this.$refs.companyTypeDOM[Mindex].style.border = '1px solid #D3D3D2')
				})
			},
			//提交表单
			submit(formName){
				let _this = this;
				_this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitDisabled = true;
						_this.items.user_id=getCookie("user")?getCookie("user"):getCookie("dzq_user_id")
						_this.$post('/apis/idle/idle',_this.items).then((res)=>{
							if(res){
								_this.$message({
									type:'success',
									message: '发布成功',
									onClose:function(){
											location.reload();
									}
								});
							}
						})
					}
				});
			}
		}
	}
</script>

<style >
.el-form-item__content{
	display: flex;
}
.el-radio{
	margin-top: 13px;
}
.el-dialog__body{
	padding: 30px 0px;
	background: #fff;
}
.el-dialog__footer{
	background: #fff;
}
.el-radio__input.is-checked+.el-radio__label{
	color:#F9BE04;
}
.el-radio__input.is-checked .el-radio__inner{
	border-color: #F9BE04;
	background: #F9BE04
}
.el-radio__inner{
	border-radius: 0;
}
.el-form-item.is-required .el-form-item__label:before{
	content: none;
}
.el-form-item__label{
	padding: 0 20px 0 0;
}
.first-select{
	height: 20px;
	line-height: 20px;
	margin-top: 8px;
	cursor: pointer;
}
.select{
	height: 20px;
	line-height: 20px;
	margin-top: 8px;
	cursor: pointer;
}
.el-select .el-input__inner{
	width: 180px;
}
.el-input__inner{
	width: 380px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/SecondHand.vue